var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9533 2.00003C9.30926 2.01237 6.7777 3.07138 4.91241 4.94541C3.04713 6.81944 1.99997 9.35594 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9465 9.34784 22.0001 12 22.0001C14.6522 22.0001 17.1957 20.9465 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34787 20.9464 6.80433 19.0711 4.92896C17.1957 3.0536 14.6522 2.00003 12 2.00003C11.9844 1.99999 11.9689 1.99999 11.9533 2.00003ZM16.0883 8.02003C16.1717 8.01837 16.3558 8.0392 16.4758 8.1367C16.5556 8.20595 16.6064 8.3026 16.6183 8.40754C16.6317 8.48503 16.6483 8.66254 16.635 8.80087C16.485 10.3825 15.8333 14.2192 15.5017 15.99C15.3617 16.74 15.0858 16.9909 14.8183 17.015C14.2383 17.0692 13.7975 16.6317 13.235 16.2634C12.355 15.6859 11.8575 15.3267 11.0033 14.7634C10.0158 14.1134 10.6558 13.755 11.2183 13.1717C11.3658 13.0184 13.9242 10.6909 13.9742 10.48C13.98 10.4534 13.9858 10.355 13.9275 10.3034C13.8692 10.2517 13.7825 10.2692 13.72 10.2834C13.6317 10.3034 12.2258 11.2334 9.5025 13.0709C9.1025 13.3459 8.74167 13.4792 8.4175 13.4709C8.06083 13.4642 7.37417 13.27 6.86333 13.1042C6.23667 12.9 5.73917 12.7925 5.7825 12.4467C5.805 12.2667 6.05333 12.0825 6.52667 11.8942C9.44167 10.6242 11.385 9.7867 12.3583 9.38254C15.135 8.22753 15.7125 8.0267 16.0883 8.02003Z",
    fill: "url(#paint0_linear_268_37256)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_268_37256",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 21.8517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.64ea852a1cc400723343e3665bbdefd2.svg";
export { ForwardRef as ReactComponent };